<div *ngIf="ready | async; else loading">
  <div *ngIf="receipt.status === 0">
    <h1>Payment receipt</h1>
    <p>
      Thank you for your purchase. The details for your transaction are shown below.
    </p>
    <p>
      You may save or print this receipt, which you will also receive by email in your Runbox account.
    </p>
  </div>

  <div *ngIf="receipt.status === 1">
    <h1>Incomplete payment</h1>
    <p>
      The details for your incomplete transaction are shown below.
    </p>
    <h4>
      To complete your payment, please follow the instructions further down.
    </h4>
    <p>
      You may save or print this receipt, which you will also receive by email in your Runbox account.
    </p>
  </div>

  <h2>
    Transaction summary
  </h2>

  <table>
    <tr>
      <td><strong> Account username: </strong></td>
      <td>{{ me.username }}</td>
    </tr>
    <tr>
      <td><strong> Time of purchase: </strong></td>
      <td>{{ receipt.time }}</td>
    </tr>
    <tr>
      <td><strong> Method: </strong></td>
      <td>{{ receipt.method }}</td>
    </tr>
    <tr>
      <td><strong>Status:</strong></td>
      <td>{{ statuses[receipt.status] }}</td>
    </tr>
    <tr>
      <td><strong> Charge: </strong></td>
      <td>{{ receipt.amount }} {{ receipt.currency }}</td>
    </tr>
    <tr>
      <td><strong> Subscription ID: </strong></td>
      <td>{{ me.uid }}</td>
    </tr>
    <tr>
      <td><strong> Transaction ID: </strong></td>
      <td>{{ receipt.tid }}</td>
    </tr>
    <tr>
      <td><strong> Product{{ receipt.products.length > 1 ? 's' : '' }}: </strong></td>
      <td>
	<div *ngFor="let p of receipt.products">
          {{ p[1] }} x {{ p[0] }}
	</div>
      </td>
    </tr>
    <p>
        If you need an invoice for this purchase, you can view it here:
        <a href="/payment/payinvoice?invoice={{ receipt.tid }}">Invoice {{ receipt.tid }}</a>
    </p>
  </table>

  <div *ngIf="receipt.status === 1 && receipt.method === 'coinbase'">
    <h2> Cryptocurrency transfer </h2>
    
    <p>
       Choose one of the available cryptocurencies below and send the correct amount (converted from USD to the desired currency) to the specified address by copying and pasting it into your cryptocurency app or scanning the QR code with your mobile phone camera.
    </p>
    
    <p>
      <strong>Please notify us via billing@runbox.com that you have paid with a cryptocurrency transfer and include your crypto address so that we can apply the payment to your account.</strong>
    </p>
    
    <p>
      Be advised that it may take 1-2 days for the payment to be registered and your subscription updated.
    </p>

    <h3>
      Runbox Crypto Addresses
    </h3>
    
    <h4>
      Bitcoin:
    </h4>
      1JvBYEa69yaKW7p1GGDioiaovZCNzoMHMQ
    <p>
      <img src="assets/payment/QR_BTC.png" class="cryptoQR" alt="BTC QR code" />
    </p>

    <h4>
      Bitcoin Cash:
    </h4>
    1NQnyrMGKAouPPoDtg2jfafKDNH1NeJFAt
    <p>
      <img src="assets/payment/QR_BCH.png" class="cryptoQR" alt="BCH QR code" />
    </p>

    <h4>
      Cardano:
    </h4>
    addr1v98n4ujsh3pnwy4wnardh65trzsrnthpfz7ws3c7e72trls8l0ywj
    <p>
      <img src="assets/payment/QR_ADA.png" class="cryptoQR" alt="ADA QR code" />
    </p>

    <h4>
      Ethereum:
    </h4>
    0xE80CE941B078792c44D465Bdd9fA73Cc92253112
    <p>
      <img src="assets/payment/QR_ETH.png" class="cryptoQR" alt="ETH QR code" />
    </p>

    <h4>
      Litecoin:
    </h4>
    M8Ta3EDbhGm5kbwWXgsKczBLzqfZfKkhsd
    <p>
      <img src="assets/payment/QR_LTC.png" class="cryptoQR" alt="LTC QR code" />
    </p>

    <h4>
      Stellar Lumens:
    </h4>
    GA7SOIZ67IUBUDVTRTKR3LD7G4ZQ74TPUPQOZKOQVEWGPGE2SEVI6TVH:::ucl:::2870389939
    <p>
      <img src="assets/payment/QR_XLM.png" class="cryptoQR" alt="XLM QR code" />
    </p>

    <h4>
      USDC:
    </h4>
    0xadd57f6d39Cc02975A5EFd17A782f4cAE2c9053c
    <p>
      <img src="assets/payment/QR_USDC.png" class="cryptoQR" alt="USDC QR code" />
    </p>

  </div>
  
  <div *ngIf="receipt.status === 1 && receipt.method === 'offline'">
    
    <h2> SWIFT transfer </h2>
    
    <p>
      Runbox Solutions accepts SWIFT and SEPA payments, but please be aware that this is an expensive payment alternative as the sender must pay the transaction cost. It may take a while for us to receive and register your payment as it cannot be automatically applied to your account.
	</p>
	<p>
	  Payment should be made from a bank account in your name, otherwise delays may occur in payments being applied to your Runbox account. Please contact us at billing@runbox.com upon paying to make sure your payment is registered as efficiently as possible.
    </p>
    
    <table>
      <tr>
        <td> IBAN:         </td> <td> NO29 1503 2111 731 </td>
      </tr><tr>
        <td> SWIFT:        </td> <td> DNBANOKKXXX </td>
      </tr><tr>
        <td> Address:      </td> <td> Runbox Solutions AS, Oscars gate 27, 0352 Oslo, Norway </td>
      </tr><tr>
        <td> Bank address: </td> <td> DNB Bank ASA, 0021 Oslo, Norway </td>
      </tr>
    </table>
    
    <h2> Cash payment </h2>
    
    <p>
      Send the cash via registered or regular mail (not recommended) to: Runbox Solutions AS, Oscars gate 27, 0352 Oslo, Norway.
    </p>
        
    <p>
	  Be advised that payments sent by regular mail may be delayed or lost, and that they require manual processing. Therefore you should send such payments well ahead (at least 3 weeks) of your trial or subscription period's expiration.</p>
	<p>
	  You may avoid delays and service disruptions by scanning (or taking a picture of) the payment prior to sending it in the mail, and emailing it to billing@runbox.com.
    </p>
    
    <p>
        Note: Please mark the payment with your Runbox username and the Transaction ID above so we can apply the payment to your account.
    </p>
  </div>
</div>

<ng-template #loading>
    <app-runbox-loading
        text="Loading receipt details..."
    >
    </app-runbox-loading>
</ng-template>
